import styled from 'styled-components';

export const Wrapper = styled.div`
  @media (min-width: 768px) {
    width: 100%;
    max-width: ${(p) => p.size}px;
    margin: auto;
    & > form {
      width: 100%;
      max-width: ${(p) => p.size}px;
      margin: auto;
    }
  }
`;
